import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Injector, Input, OnInit, Output, Type, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { DateTimeModel } from './date-time.model';
import { NgbDate, NgbDateStruct, NgbDatepicker, NgbPopover, NgbPopoverConfig, NgbTimeStruct, NgbTimepicker } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { AbstractCustomControl, MakeProvider, MakeValidator } from '../abstract-custom-control';
import { Focusable } from '../../interfaces/focusable';
import { ModalService } from '../../base-services/modal.service';
import { ConfirmationDialogButtons } from '../confirmation-dialog/confirmation-dialog-buttons';




@Component({
  selector: 'yt-date-time-picker-popup',
  templateUrl: './date-time-picker-popup.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    DatePipe,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateTimePickerPopupComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => DateTimePickerPopupComponent),
      multi: true
    }
    // DatePipe,
    // {
    //   provide: NG_VALUE_ACCESSOR,
    //   useExisting:  DateTimePickerPopupComponent,
    //   multi: true,
    // },
  ],
})
export class DateTimePickerPopupComponent extends AbstractCustomControl<any> implements ControlValueAccessor, OnInit, AfterViewInit, Focusable {

  //promenljiva u koju se smešta vrednost datuma i vremena
  @Input()
  dateString: string;
  //definisanje formata u kom će podaci biti prikazani
  @Input()
  inputDatetimeFormat = 'dd.MM.yyyy. HH:mm';
  //korak za sate
  @Input()
  hourStep: number=1;
  //korak za minute
  @Input()
  minuteStep: number=15;
  //korak za sekunde
  // @Input()
  // secondStep: number=30; da omogucimo sekunde da se povecavaju za 30sec samo ovo od-komentarisati i u html staviti [secondStep]="secondStep" 

  //boolean promenljiva koja odredjuje da li će se deo za sekunde prikazivati ili ne
  // @Input()
  // seconds = true; da omogucimo da se vide sekunde od-komentarisati ovo i staviti [seconds]="seconds u htmlu


  // disablovanje kontrole ali omogucavanje da se kalendar koristi i menja vrednosti.
  @Input() readonly: boolean = false;
  time: NgbTimeStruct = {hour: 7, minute: 0, second: 0};
  @Input() MinTime: number = 0; // default minimum time
  @Input() MaxTime: number = 23; // default maximum time
  @Input() MinDay: number = 1;
  @Input() MaxDay: number = 5;

  @Input() linkTo: DateTimePickerPopupComponent;   
  @Input() linkOffsetMinutes: number = 60;    
  private linking = false;                       

  @Output() OnDateSelected = new EventEmitter();
  
  // @Input()
  // disabled = false;

  // @Input() Label: string;

  // @ViewChild('placeholder',null) placeholder: ElementRef
  // @ViewChild('inputControl',null) inputControl: ElementRef
  // @ViewChild('toggleButton',null) toggleButton: ElementRef;
  // @ViewChild('errorIcon',null) errorIcon: ElementRef;
  // @ViewChild('tp',null)

  @ViewChild('placeholder',{ static: true }) placeholder: ElementRef
  @ViewChild('inputControl',{ static: true }) inputControl: ElementRef
  @ViewChild('toggleButton',{ static: true }) toggleButton: ElementRef;
  @ViewChild('errorIcon',{ static: true }) errorIcon: ElementRef;
  @ViewChild('tp',{ static: true })

  private timePicker: NgbTimepicker;
  showTimePickerToggle = false;
  isDateSelected: boolean = false;
  datetime: DateTimeModel = new DateTimeModel();
  private firstTimeAssign = true;

  @ViewChild('dp',{ static: true }) dp: NgbDatepicker;
  private today = new Date();
  @ViewChild(NgbPopover,{ static: true })
  private popover: NgbPopover;
  startDate = new NgbDate(this.today.getFullYear(),this.today.getMonth() + 1, this.today.getDate())

  constructor(private config: NgbPopoverConfig, 
              private inj: Injector,
              protected changeDetectorRef: ChangeDetectorRef,
              protected modalService: ModalService) {
                super(changeDetectorRef);
                config.autoClose = 'outside'; 
                config.placement = 'auto';
  }



  ngOnInit(): void {
    // if (!this.datetime.hour) {
    //   const now = new Date();
    //   const minutes = Math.ceil(now.getMinutes() / this.minuteStep) * this.minuteStep;
    //   this.datetime.hour = now.getHours();
    //   this.datetime.minute = minutes < 60 ? minutes : 0;
    //   if (minutes >= 60) {
    //     this.datetime.hour++;
    //   }
    // }
    this.isDateSelected = false;
  }
  

  ngAfterViewInit(): void {
    this.setSize();
  }

  @HostListener('keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === "ArrowDown") {
      this.toggleDateTimeState(event);
    }
  }

  dateChanged(value){
      this.OnDateSelected.emit(value);
  }
  
  
  focus(){
    this.inputControl.nativeElement.focus();
  }

  setSize(){
    if(this.inputControl.nativeElement.offsetWidth > 0){
      this.placeholder.nativeElement.style.width = this.inputControl.nativeElement.offsetWidth + 'px';
      this.errorIcon.nativeElement.style.left = this.inputControl.nativeElement.offsetWidth - 5 + 'px';
    }
  }

  writeValue(newModel: string) {
    super.writeValue(newModel);
    if (newModel) {
        // Dodajte sufiks "Z" ako ga nema da bi se vreme interpretiralo kao UTC
        if (!newModel.endsWith("Z")) {
            newModel += "Z";
        }

        const utcDate = new Date(newModel); 

        this.isDateSelected = true;

        this.dateString = this.fromDateTimeToString(utcDate);
        this.datetime = DateTimeModel.fromStringToDateTime(this.dateString);
        this.validateTime({
          hour: this.datetime.hour,
          minute: this.datetime.minute,
          second: this.datetime.second
        });
    } else {
        this.isDateSelected = false;
        this.dateString = '';
        this.datetime = new DateTimeModel();
    }

  this.changeDetectorRef.markForCheck();
  this.changeDetectorRef.detectChanges();

}


private fromDateTimeToString(date: Date): string {
  const year = date.getFullYear();
  const month = this.pad(date.getMonth() + 1);
  const day = this.pad(date.getDate());
  const hours = this.pad(date.getHours());
  const minutes = this.pad(date.getMinutes());
  const seconds = this.pad(date.getSeconds());

  // Formatiranje kao ISO string sa "Z" sufiksom
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}


private pad(n: number): string {
    return n < 10 ? '0' + n : n.toString();
}

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  toggleDateTimeState(event) {
    event.stopPropagation();
    if (this.popover.isOpen()) {
      this.popover.close();
    } else {
      this.popover.open();
    }
  }
  
  setDisabledState(isDisabled: boolean){
    super.setDisabledState(isDisabled);
    this.inputControl.nativeElement.disabled = isDisabled;
    this.toggleButton.nativeElement.disabled = isDisabled;
    //this.clearButton.nativeElement.disabled = isDisabled;
  }
  
  onInputChange($event: any) {
    const value = $event.target.value;
    const dt = DateTimeModel.fromUTCString(value);

    if (dt) {
        this.datetime = dt;
          this.isDateSelected = true;
        this.setDateStringModel();
    } else if (value.trim() === '') {
        this.datetime = new DateTimeModel();
        this.dateString = '';
        this.onChange(this.dateString);
    } else {
        this.onChange(value);
    }
}
onDateChange(d: NgbDateStruct) {
  if (!d) {
    this.isDateSelected = false;
    this.changeDetectorRef.markForCheck();
    return;
  }

  this.isDateSelected = true;  

  const now = new Date();

  const hourValid = Number.isInteger(this.datetime?.hour);
  const minValid  = Number.isInteger(this.datetime?.minute);

  this.refreshModel({
    year: d.year,
    month: d.month,
    day: d.day,
    hour: hourValid ? this.datetime.hour : now.getHours(),
    minute: minValid ? this.datetime.minute : now.getMinutes(),
    second: 0
  });

  this.setDateStringModel();
  this.changeDetectorRef.markForCheck();
}

onTimeChange(event: NgbTimeStruct) {
  if (event && event.hour != null && event.minute != null) {
    if (Number.isInteger(event.hour) && Number.isInteger(event.minute)) {
      if (event.hour >= this.MinTime && event.hour <= this.MaxTime) {
        this.datetime.hour = event.hour;
        this.datetime.minute = event.minute;
        this.datetime.second = event.second;
        this.validateTime(event);
        this.setDateStringModel();
      } else {
        if (event.hour < this.MinTime) {
          this.datetime.hour = this.MinTime;
        } else if (event.hour > this.MaxTime) {
          this.datetime.hour = this.MaxTime;
        }
        this.datetime.minute = 0; 
        this.datetime.second = 0;
        this.validateTime(event);
        this.setDateStringModel();
      }
    } 
  }
}

setDateStringModel() {
  if (this.datetime.year && this.datetime.month && this.datetime.day) {
    const localDate = new Date(
      this.datetime.year,
      this.datetime.month - 1,
      this.datetime.day,
      this.datetime.hour || 0,
      this.datetime.minute || 0,
      this.datetime.second || 0
    );

    if (!isNaN(localDate.getTime())) {
      this.dateString = localDate.toISOString();

      this.onChange(this.dateString);

      // if (!this.firstTimeAssign) {
      //   this.onChange(this.dateString);
      // } else {
      //   if (this.dateString !== null) {
      //     this.firstTimeAssign = false;
      //   }
      // }
    }

if (this.linkTo && !this.linking) {
  const start = new Date(this.dateString);
  if (!isNaN(start.getTime())) {
    const end = new Date(start.getTime() + this.linkOffsetMinutes * 60000);
    try {
      this.linking = true;
      this.linkTo.writeValue(end.toISOString());   
      (this.linkTo as any).onChange(end.toISOString()); 
      this.linkTo.changeDetectorRef.markForCheck();    
      this.linkTo.changeDetectorRef.detectChanges();
    } finally {
      this.linking = false;
    }
  }
}
    this.OnDateSelected.emit(this.dateString); 
  }
}

setToday() {
  const now = new Date();

  const roundedMinutes =
    Math.floor(now.getMinutes() / this.minuteStep) * this.minuteStep;

  this.isDateSelected = true;

  this.refreshModel({
    year: now.getFullYear(),
    month: now.getMonth() + 1,
    day: now.getDate(),
    hour: now.getHours(),
    minute: roundedMinutes,
    second: 0
  });

  this.startDate = new NgbDate(this.datetime.year, this.datetime.month, this.datetime.day);

  this.setDateStringModel();

  // Ovu liniju ostavljam zakomentarisanu jer se bug koji bi ovo trebalo da reši u međuvremenu prestao javljati
  // bug je bio taj, da ako kontrola nema setu vrednost i mi samo kliknemo na ovaj taster
  // vrednost se prikaže u kontroli, ali formcontrol vrednost bude null
  this.onChange(this.dateString);

  this.changeDetectorRef.markForCheck();
  this.changeDetectorRef.detectChanges();
}


setTodayRound(): DateTimeModel{
  const today = new Date();
  
  this.datetime.year = today.getFullYear();
  this.datetime.month = today.getMonth() + 1; 
  this.datetime.day = today.getDate();

  const minutes = today.getMinutes();
  const roundedMinutes = Math.floor(minutes / this.minuteStep) * this.minuteStep; 
  this.datetime.hour = today.getHours();
  this.datetime.minute = roundedMinutes;

  this.datetime.second = 0;

  return this.datetime;
}

  inputBlur($event) {
    this.onTouched();
  }
  isToday(date: NgbDate){
    return date.day == this.today.getDate() && date.month == this.today.getMonth() + 1 && date.year == this.today.getFullYear();
  }

  validateTime(time: NgbTimeStruct): void {
    let { hour, minute } = time;
  
    if (!Number.isInteger(hour) || !Number.isInteger(minute)) {
      this.modalService.ShowConfirmationDialog(
        "Obaveštenje",
        "Unesite validan broj za sate i minute, a ne slova i specijalne karaktere.",
        "alert",
        ConfirmationDialogButtons.Ok
      );
      return;
    }
  
    if (hour < this.MinTime || hour > this.MaxTime) {
      this.modalService.ShowConfirmationDialog(
        "Obaveštenje",
        `Uneti sati nisu u dozvoljenom opsegu od ${this.MinTime}h do ${this.MaxTime}h.`,
        "alert",
        ConfirmationDialogButtons.Ok
      );
      hour = Math.max(this.MinTime, Math.min(hour, this.MaxTime));
      minute = 0; 
    }
  
    if (minute % this.minuteStep !== 0) {
      this.modalService.ShowConfirmationDialog(
        "Obaveštenje",
        `Minuti moraju biti u koracima od ${this.minuteStep} minuta.`,
        "alert",
        ConfirmationDialogButtons.Ok
      );
      minute = Math.floor(minute / this.minuteStep) * this.minuteStep;
    }
  
    if (hour === this.MaxTime && minute > 0) {
      this.modalService.ShowConfirmationDialog(
        "Obaveštenje",
        `Minute moraju biti 0 kada su sati na maksimalnom limitu od ${this.MaxTime}h.`,
        "alert",
        ConfirmationDialogButtons.Ok
      );
      minute = 0;
    }
  
    this.datetime.hour = hour;
    this.datetime.minute = minute;
    this.datetime.second = 0; 
  
    this.setDateStringModel();
  }
  closePicker() {
  if (this.popover.isOpen()) {
    this.popover.close();
  }
}

private refreshModel(patch: Partial<DateTimeModel>) {
  const base = this.datetime ?? new DateTimeModel();
  this.datetime = Object.assign(new DateTimeModel(), base, patch);

  this.changeDetectorRef.markForCheck();
}

}
